import React from "react";
import { FormWithRedirect } from "react-admin";

import { WizardFormView } from "./WizardFormView";

const WizardForm = ({ children, toolbarComponent, defaultStepNumber, saveDisabled, ...props }) => {
	const steps = React.Children.toArray(children);
	return (
		<FormWithRedirect
			{...props}
			render={(formProps) => (
				<WizardFormView
					steps={steps}
					toolbarComponent={toolbarComponent}
					defaultStepNumber={defaultStepNumber}
					saveDisabled={saveDisabled}
					{...formProps}
				/>
			)}
		/>
	);
};

export default WizardForm;
